(($, Drupal) => {
  Drupal.behaviors.mainShop = {
    attach: function attach() {
      function setActiveClassToRate(card, rateContainer, rateItem) {
        $(card).each(function (index) {
          const starWrap = $(this).find(rateContainer);
          const starEl = $(this).find(rateItem);
          const dataValue = starWrap.data('rate');

          for (let i = 0; i < dataValue; i++) {
            $(starEl[i]).addClass('active');
          }
        });
      }

      $('.shop-block').once('add').each((index) => {
        setActiveClassToRate('.shop-teaser', '.availability', '.availability__item');
        setActiveClassToRate('.shop-teaser', '.rate', '.rate__star');
      });

      $('.shop-page').once('add').each((index) => {
        setActiveClassToRate('.shop-teaser-vr', '.availability', '.availability__item');
        setActiveClassToRate('.shop-teaser-vr', '.rate', '.rate__star');
      });

      $('.single-shop').once('add').each(function (index) {
        setActiveClassToRate(this, '.availability', '.availability__item');
        setActiveClassToRate(this, '.rate', '.rate__star');
      });
    },
  };
})(jQuery, Drupal);
